<template>
    <div class="quiz-result-master mx-auto flex flex-col items-center w-full h-full">
        <div class="section-top flex items-center w-full">
            <div class="bg-main-container w-auto h-full overflow-hidden" v-if="questionImage">
                <ImageQuestion
                    :path="questionImage"
                    size="full"
                    :class="{ 'bg-main': true, 'animate-reveal': questionType === 'reveal_image' }"
                ></ImageQuestion>
            </div>
            <div
                class="box py-4 md:py-2 px-4 md:px-8 flex-1 flex w-full h-full freeze"
                :style="[setting.bgBox ? { backgroundColor: 'rgba(0, 0, 0, 0.3)', border: 'none' } : {}]"
            >
                <div class="flex-1 text-center md:text-left">
                    <span id="question-type" class="theme-question-text-color theme-question-shadow">{{
                        questionTypeName
                    }}</span>
                    <h1
                        id="question-title"
                        class="theme-question-text-color theme-question-shadow font-bold text-white m-0"
                    >
                        {{ title ? title : '-' }}
                    </h1>
                </div>
                <div class="flex flex-col justify-center items-center row-gap-16">
                    <button
                        v-if="correctAnswer"
                        @click="handleShowChoices"
                        class="theme-button btn btn-large uppercase font-opensans font-size-18 w-full break-words"
                        ref="showChoicesBtn"
                        id="show-choice-button"
                    >
                        {{ $t('playlive_master_result_button_show_choice') }}
                    </button>
                    <button
                        v-if="correctAnswer"
                        @click="handleShowCorrectAnswer"
                        class="theme-button btn btn-large uppercase font-opensans font-size-18 w-full break-words"
                        ref="showCorrectBtn"
                        id="show-correct-button"
                    >
                        {{ $t('playlive_master_result_button_show_correct') }}
                    </button>
                </div>
            </div>
        </div>

        <div class="section-content flex-1 flex w-full h-full overflow-hidden">
            <div
                :class="{
                    'box xl:block w-full scroll-on-mobile p-4 md:pl-8 w-full h-full overflow-hidden freeze': true,
                    'justify-center': isPlayersCenter
                }"
                :style="[setting.bgBox ? { backgroundColor: 'rgba(0, 0, 0, 0.3)', border: 'none' } : {}]"
            >
                <div class="w-full h-full overflow-y-auto">
                    <template v-if="list.length > 0">
                        <div class="my-0 w-full" v-for="(item, index) in list" :key="index">
                            <div
                                :id="`answer-${index + 1}`"
                                :key="result.id"
                                v-for="(result, index) in item"
                                class="max-w-lg items-center flex justify-start mb-1 flex-row mb-2"
                            >
                                <div class="w-full answer-container">
                                    <div class="flex items-center mb-2">
                                        <span
                                            style="margin-left: -22px"
                                            v-if="playerName.length && playerName == result.name"
                                            class="fas fa-arrow-right text-white inline-block pr-2"
                                        ></span>
                                        <span
                                            class="theme-ui-text-color theme-question-shadow text-white player-number"
                                        >
                                            {{ result.number }}.
                                        </span>
                                        <span
                                            class="theme-ui-text-color theme-question-shadow inline-block text-white player-name uppercase"
                                        >
                                            {{ result.name }}
                                        </span>
                                        <div class="flex items-center">
                                            <template v-if="setting.icon">
                                                <i
                                                    v-if="result.result"
                                                    class="theme-question-shadow fas fa-check-circle text-white mr-2 theme-ui-text-color"
                                                ></i>
                                                <i
                                                    v-if="!result.result"
                                                    class="theme-question-shadow fas fa-times-circle text-white mr-2 theme-ui-text-color"
                                                ></i>
                                            </template>
                                            <template v-if="setting.playerAnswersBox">
                                                <template
                                                    v-if="
                                                        questionType != 'sorting_list' &&
                                                        questionType != 'puzzle' &&
                                                        questionType != 'typing_question' &&
                                                        questionType != 'scramble'
                                                    "
                                                >
                                                    <div>
                                                        <div
                                                            :key="key"
                                                            v-for="(item, key) in renderAnswer(result.answerIndex)"
                                                            class="flex h-full items-center both-img-text"
                                                        >
                                                            <div v-if="item.image">
                                                                <div
                                                                    class="img"
                                                                    :style="{ backgroundImage: `url(${item.image})` }"
                                                                ></div>
                                                            </div>

                                                            <div v-if="!item.image" class="both-text">
                                                                <span
                                                                    class="theme-ui-text-color theme-question-shadow block text-center md:break-words break-words text-white answer-text w-full mr-2"
                                                                >
                                                                    {{ item.title }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>

                                                <div v-if="questionType === 'typing_question'" class="typing-custom">
                                                    <span
                                                        v-for="(item, key) in checkTypingAnswer(
                                                            result.typingAnswer,
                                                            result.answerIndex,
                                                            index
                                                        )"
                                                        :key="key"
                                                        :id="`answerTyping-${index + 1}`"
                                                        class="theme-ui-text-color theme-question-shadow answer-typing md:break-words break-words text-white uppercase answer-text"
                                                    >
                                                        {{ item.title }}
                                                    </span>
                                                </div>

                                                <div
                                                    v-if="questionType === 'sorting_list'"
                                                    class="flex flex-wrap justify-center"
                                                >
                                                    <div
                                                        v-if="
                                                            isAllText(
                                                                checkSortingAnwer(
                                                                    result.sortingResult,
                                                                    result.answerIndex
                                                                )
                                                            )
                                                        "
                                                    >
                                                        <span
                                                            class="theme-ui-text-color theme-question-shadow block text-center md:break-words break-words text-white uppercase answer-text w-full"
                                                        >
                                                            {{
                                                                checkSortingAnwer(
                                                                    result.sortingResult,
                                                                    result.answerIndex
                                                                )
                                                                    .join(', ')
                                                                    .replace(
                                                                        $t('playlive_master_result_type'),
                                                                        $t('playlive_master_result_sort')
                                                                    )
                                                            }}
                                                        </span>
                                                    </div>

                                                    <div
                                                        v-if="
                                                            !isAllText(
                                                                checkSortingAnwer(
                                                                    result.sortingResult,
                                                                    result.answerIndex
                                                                )
                                                            )
                                                        "
                                                        class="flex flex-wrap justify-center sorting-container"
                                                    >
                                                        <div
                                                            v-for="(item, key) in checkSortingAnwer(
                                                                result.sortingResult,
                                                                result.answerIndex
                                                            )"
                                                            :key="key"
                                                            class="flex items-center both-img-text"
                                                        >
                                                            <div v-if="isImage(item)">
                                                                <div
                                                                    class="img mr-2 md:mr-2 ml-2 md:ml-2"
                                                                    :style="{ backgroundImage: `url(${item})` }"
                                                                ></div>
                                                            </div>

                                                            <div v-else class="both-text">
                                                                <span
                                                                    class="theme-ui-text-color theme-question-shadow p-2 md:p-2 block text-center md:break-words break-words text-white uppercase answer-text w-full mr-2"
                                                                >
                                                                    {{ item }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div v-if="questionType === 'scramble'" class="typing-custom">
                                                    <span
                                                        v-for="(item, key) in checkTypingAnswer(
                                                            result.typingAnswer,
                                                            result.answerIndex,
                                                            index
                                                        )"
                                                        :key="key"
                                                        class="theme-ui-text-color theme-question-shadow answer-typing md:break-words break-words text-white uppercase answer-text"
                                                        :id="`answerScramble-${index + 1}`"
                                                    >
                                                        {{ item.title }}
                                                    </span>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="flex w-full h-full">
                <div
                    class="box flex-1 p-4 relative freeze"
                    :style="[setting.bgBox ? { backgroundColor: 'rgba(0, 0, 0, 0.3)', border: 'none' } : {}]"
                >
                    <p
                        class="theme-ui-text-color theme-question-shadow text-white font-bold md:font-size-20 xl:font-size-24 text-center"
                    >
                        {{ $t('playlive_master_result_answers', { userCount: userCount, playerCount: playerCount }) }}
                    </p>
                    <div class="answer-count-box flex justify-between w-1/2 absolute">
                        <div>
                            <i
                                class="theme-ui-text-color theme-question-shadow fas fa-check-circle text-white answer-icon"
                            ></i>
                            <p class="theme-ui-text-color theme-question-shadow answer-count text-white text-center">
                                {{ correctCount }}
                            </p>
                        </div>
                        <div>
                            <i
                                class="theme-ui-text-color theme-question-shadow fas fa-times-circle text-white answer-icon"
                            ></i>
                            <p class="theme-ui-text-color theme-question-shadow answer-count text-white text-center">
                                {{ wrongCount }}
                            </p>
                        </div>
                    </div>
                </div>
                <div
                    v-show="setting.topPlayerBox"
                    class="box flex-1 p-4 md:pl-8 freeze"
                    :style="[setting.bgBox ? { backgroundColor: 'rgba(0, 0, 0, 0.3)', border: 'none' } : {}]"
                >
                    <p
                        class="theme-ui-text-color theme-question-shadow text-white font-bold md:font-size-20 xl:font-size-24 text-center"
                    >
                        {{ $t('playlive_top_3') }}
                    </p>
                    <div class="mt-4">
                        <div
                            v-for="(top, index) in top3"
                            :key="index"
                            class="theme-ui-text-color theme-question-shadow player-name text-white mb-2 uppercase"
                        >
                            {{ index + 1 }}. {{ currentQuizIndex + 1 == questionCount ? '****' : top.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ImageQuestion from '@/components/ImageQuestion.vue'
import helper from '@/lib/helper.js'
import gsap from 'gsap'

export default {
    components: {
        ImageQuestion
    },

    props: {
        userType: String,
        title: String,
        questionType: String,
        questionRequired: String,
        correctAnswer: Array,
        results: Array,
        answers: Array,
        playerResult: {
            default: ''
        },
        showSummary: Boolean,
        playerName: {
            type: String,
            default: ''
        },
        questionImage: String,
        questionPreviewSize: {
            type: String,
            default: 'large'
        },
        revealImage: Boolean,
        scaleImage: Boolean,
        userCount: String,
        playerCount: String,
        currentQuizIndex: [String, Number],
        questionCount: [String, Number],
        correctCount: Number,
        wrongCount: Number,
        top3: Array,
        setting: Object
    },

    data: function () {
        return {
            list: [],
            isPlayersCenter: true,
            innerWidth: window.innerWidth,
            questionTypeName: ''
        }
    },

    watch: {
        results(resultsValue) {
            this.setAnswerList(resultsValue)
        }
    },

    created() {
        this.questionTypeName = this.checkQuestionTypeName(this.questionType)

        if (this.title) {
            helper.quizFontSize('question-title', this.title.length)
        }

        this.$nextTick(() => {
            setTimeout(() => {
                window.dispatchEvent(new CustomEvent('componentAlready'))
            }, 200)
        })
    },

    mounted() {
        this.playBoxAnimation()
        this.checkImageType()
    },

    methods: {
        renderAnswerTitle(answer) {
            var results = []
            results = answer
            results = results.filter(answer => Array.isArray(answer.titleAnswer))

            return results
        },

        isAllText(answers) {
            let found
            if (answers.length >= 0) {
                found = answers.filter(answer => answer.indexOf('http://') > -1 || answer.indexOf('https://') > -1)
            }

            return found.length == 0
        },

        isImage(val) {
            let result = val.indexOf('http://') > -1 || val.indexOf('https://') > -1

            return result
        },

        checkSortingAnwer(resultSorting, answerIndex) {
            var results = []
            var titleAnswer = []

            if (answerIndex === -1) {
                results.push(this.$t('playlive_master_result_not_type_answer'))
            }

            if (answerIndex != -1) {
                resultSorting.forEach(index => {
                    results.push({
                        title: this.answers[index].title,
                        image: this.answers[index].image
                    })
                })
                results = results.map(ans => {
                    return ans.image ? ans.image : ans.title
                })
            }

            return results
        },

        checkTypingAnswer(resultAswer, resultIndex, index) {
            var result = []

            result.push({
                title: resultAswer
            })

            if (resultIndex == -1) {
                result[0].title = this.$t('playlive_master_result_not_type_answer')
            }

            if (result[0] && result[0].title.trim() == '') {
                result[0].title = this.$t('playlive_master_result_not_type_answer')
            }

            return result
        },

        renderAnswer(answerIndex) {
            var results = []

            if (answerIndex === -1) {
                results.push({
                    title: this.$t('playlive_master_result_not_type_answer'),
                    image: ''
                })
            }

            if (answerIndex != -1) {
                answerIndex.forEach(index => {
                    results.push({
                        title:
                            this.questionType != 'hotspot' || !this.answers[index].name
                                ? this.answers[index].title
                                : this.answers[index].name,
                        image: this.answers[index].image
                    })
                })
            }

            return results
        },

        handleShowCorrectAnswer: function () {
            const rect = this.$refs.showCorrectBtn.getBoundingClientRect()

            this.$emit('showCorrectAnswer', rect)
        },

        handleShowChoices: function () {
            const rect = this.$refs.showChoicesBtn.getBoundingClientRect()

            this.$emit('showChoices', rect)
        },

        checkImageType() {
            // if (this.revealImage) {
            //     gsap.set('.bg-main', { filter: 'blur(10px)' })
            //     gsap.to('.bg-main', { filter: 'blur(0px)', duration: 10, ease: 'none' })
            // }

            if (this.scaleImage) {
                gsap.set('.bg-main', { backgroundSize: '500% 500%' })
                gsap.to('.bg-main', { backgroundSize: '100% 100%', duration: 10, ease: 'none' })
            }
        },

        setAnswerList(resultsValue) {
            let transformData = []
            if (resultsValue.length > 0) {
                let maxLength = 6
                let arraySize = resultsValue.length
                if (resultsValue.length >= maxLength && window.innerWidth > 767) {
                    arraySize = Math.ceil(resultsValue.length / 3)
                }

                if (resultsValue.length >= maxLength && window.innerWidth < 769 && window.innerWidth > 425) {
                    arraySize = Math.ceil(resultsValue.length / 2)
                }

                if (resultsValue.length >= maxLength && window.innerWidth < 426) {
                    arraySize = Math.ceil(resultsValue.length / 1)
                }

                transformData = resultsValue.map((item, index) => {
                    return {
                        ...item,
                        number: index + 1
                    }
                })

                this.list = helper.chunk(transformData, arraySize)

                if (this.list.length >= 6) {
                    this.isPlayersCenter = false
                } else {
                    this.isPlayersCenter = true
                }
            } else {
                this.list = []
            }
        },

        checkQuestionTypeName(val) {
            if (val == 'typing_question') {
                return 'Typing Question'
            }

            if (val == 'sorting_list') {
                return 'Sorting List'
            }

            if (val == 'scale_image') {
                return 'Scale Image'
            }

            if (val == 'reveal_image') {
                return 'Reveal Image'
            }

            return val
        },

        playBoxAnimation() {
            const boxes = document.querySelectorAll('.box')

            for (const [index, box] of boxes.entries()) {
                setTimeout(() => {
                    box.classList.remove('freeze')
                }, 100 * index)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.quiz-result-master {
    max-width: 1800px;
    row-gap: 1rem;
    padding: 0 1rem;

    @media screen and (max-width: 1199px) and (orientation: landscape) {
        padding: 0 4rem;
    }

    @media screen and (max-width: 767px) {
        padding: 0 1rem 1rem 1rem;
        height: auto;
    }

    .section-top {
        position: relative;
        gap: 1rem 4rem;
        height: 30%;

        @media screen and (max-width: 1199px) and (orientation: portrait) {
            flex-direction: column;
            height: auto;
        }

        @media screen and (max-width: 767px) {
            flex-direction: column;
            height: auto;
        }

        .bg-main-container {
            aspect-ratio: 1 / 1;
            border-style: solid;
            border-color: var(--ui-color);
            --border-radius: 1rem;

            @media screen and (max-width: 1199px) and (orientation: portrait) {
                flex: 1;
                width: 20%;
            }

            @media screen and (max-width: 767px) {
                flex: 1;
                width: 40%;
                --border-radius: 0.5rem;
            }

            &::before {
                border: none;
            }

            .bg-main {
                &.animate-reveal {
                    animation: reveal 10s none;
                }
            }

            @keyframes reveal {
                0% {
                    filter: blur(10px);
                }

                100% {
                    filter: blur(0);
                }
            }
        }

        #question-title {
            font-size: 1.875rem;

            @media screen and (max-width: 1199px) {
                font-size: 1.5rem;
            }

            @media screen and (max-width: 767px) {
                font-size: 1.25rem;
            }
        }

        .box {
            @media screen and (max-width: 1199px) and (orientation: portrait) {
                flex: unset;
                height: 180px;
            }
            @media screen and (max-width: 767px) {
                flex-direction: column;
                height: auto;
            }
        }
    }

    .section-content {
        gap: 1rem;

        @media screen and (max-width: 1199px) and (orientation: portrait), (max-width: 767px) {
            flex-direction: column;
        }

        > div {
            gap: 1rem;
        }

        > div:first-of-type {
            flex: 1;
            order: 1;

            @media screen and (max-width: 1199px) and (orientation: portrait) {
                order: 2;
            }

            @media screen and (max-width: 767px) {
                order: 2;
                flex: unset;
                height: auto;
            }

            > div {
                @media screen and (max-width: 767px) {
                    flex: unset;
                    height: 500px;
                }
            }

            i {
                font-size: 20px;

                @media screen and (max-width: 767px) {
                    font-size: 14px;
                }
            }
        }

        > div:last-of-type {
            flex: 1;
            flex-direction: column;
            order: 2;

            @media screen and (max-width: 1199px) and (orientation: portrait) {
                flex: unset;
                height: 220px;
                flex-direction: row;
                order: 1;
            }

            @media screen and (max-width: 767px) {
                flex: unset;
                flex-direction: column;
                height: 330px;
                order: 1;
            }
        }
    }

    .box {
        border: 1px solid #fff;
        border-radius: 1rem;
        gap: 1rem;
        transform: scale(1);
        opacity: 1;
        transition: opacity 0.5s ease, background-color 0.5s ease, border-color 0.5s ease, transform 0.5s ease;

        @media screen and (max-width: 767px) {
            transform: unset !important;
            opacity: 1 !important;
            transition: unset !important;
        }

        &.freeze {
            transform: scale(0.9);
            opacity: 0;
        }

        > div {
            &::-webkit-scrollbar {
                width: 10px;

                @media screen and (max-width: 767px) {
                    width: 4px;
                }
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 10px;
                background-color: rgba(255, 255, 255, 0.2);

                @media screen and (max-width: 767px) {
                    border-radius: 4px;
                }
            }
        }

        #question-type {
            font-size: 1.125rem;
            text-transform: capitalize;
            color: #fff;

            @media screen and (max-width: 767px) {
                font-size: 0.875rem;
            }
        }

        .player-number,
        .player-name,
        .answer-text {
            font-size: 1.25rem;

            @media screen and (max-width: 767px) {
                font-size: 0.875rem;
            }
        }

        .player-number {
            width: 15%;

            @media screen and (max-width: 1199px) {
                width: 10%;
            }
        }

        .player-name {
            min-width: 30%;

            @media screen and (max-width: 1199px) {
                min-width: 25%;
            }

            @media screen and (max-width: 767px) {
                min-width: 30%;
            }
        }

        .answer-count-box {
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            @media screen and (max-width: 767px) {
                position: unset;
                top: 0;
                left: 0;
                transform: unset;
                margin: 1rem auto 0 auto;
            }

            .answer-icon {
                font-size: 3.75rem;

                @media screen and (max-width: 1199px) {
                    font-size: 3.125rem;
                }
            }

            .answer-count {
                font-size: 2.5rem;

                @media screen and (max-width: 1199px) {
                    font-size: 1.5rem;
                }
            }
        }
    }

    .answer-typing {
        word-break: break-all;
    }

    .img {
        display: flex;
        width: 100%;
        background-size: cover;
        background-position: center;
        height: 3em;
        width: 3em;
        border-radius: 50%;
    }

    .min-width {
        min-width: 20rem;
    }

    .column-gap-16 {
        column-gap: 16px;
    }

    .row-gap-16 {
        row-gap: 16px;
    }
}

@media screen and (max-width: 830px) {
    li {
        max-width: 30rem;
    }
    .typing-custom {
        margin-right: 2rem;
        max-width: 100%;
    }
}

@media screen and (max-width: 500px) {
    li {
        max-width: 15rem;
    }
    .player-name {
        min-width: auto;
        max-width: fit-content;
    }
    .both-img-text {
        justify-content: center;
    }
    .both-text {
        width: 100%;
    }
}

@media screen and (max-width: 380px) {
    .sorting-container {
        display: block;
    }
}
</style>
